import React from 'react'
import { Row, Col, Button, Upload } from 'antd'
import { LatLng } from '@slerp/controls'
import { useSession } from '@slerp/accounts'
import { kml } from '@tmcw/togeojson'
import { DOMParser } from 'xmldom'

type Coordinate = [number, number, number]

const ReadKml = ({ onUpload }: { onUpload: (path: LatLng[]) => void }) => {
  const { user } = useSession()

  const readKML = (file: File) => {
    const reader = new FileReader()

    reader.readAsText(file)
    reader.onload = () => {
      const parser = new DOMParser()
      const kmlFromFile = parser.parseFromString(reader.result)
      const geoJSON = kml(kmlFromFile)
      const deliveryPaths = geoJSON.features[0].geometry.coordinates[0].map(
        (coords: Coordinate) => {
          return { lng: coords[0], lat: coords[1] }
        }
      )

      onUpload(deliveryPaths)
    }
  }

  const handleBeforeUpload = (file: File) => {
    readKML(file)
  }

  return ['superadmin'].includes(user?.role) ? (
    <Row className='_my-12' justify='center'>
      <Col className='_mx-6'>
        <Upload itemRender={() => {}} beforeUpload={handleBeforeUpload}>
          <Button>Upload KML</Button>
        </Upload>
      </Col>
    </Row>
  ) : null
}

export default ReadKml
